import { useEffect, useRef } from 'react';

type UseCommonLayoutProps = {
  isUsed?: boolean;
  useShareButton?: boolean;
};

export const useCommonLayout = ({ isUsed, useShareButton }: UseCommonLayoutProps) => {
  const gnbRef = useRef<HTMLElement | null>(document.querySelector('#commonLayoutGnb'));
  const headerRef = useRef<HTMLElement | null>(document.querySelector('#commonLayoutHeader'));
  const fabRef = useRef<HTMLElement | null>(document.querySelector('#commonLayoutFab'));

  useEffect(() => {
    if (
      headerRef.current === undefined ||
      fabRef.current === undefined ||
      gnbRef.current === undefined ||
      !window.commonLayoutPc
    ) {
      return;
    }

    window.userLogData = {
      page_id: window.location.pathname,
    };

    const options = {
      contentSize: 'max600',
      appbar: {
        use: false,
      },
      gnb: {
        customBgColor: undefined,
        storeCode: undefined,
      },
      fab: {
        use: false,
        useTopButton: true,
        useRecentButton: true,
        useGlobalFilter: false,
        useShareButton,
      },
      footer: {
        use: false,
      },
    };

    if (window?.commonLayoutPc?.render) {
      window.commonLayoutPc.render({
        containers: ['gnb', 'header', 'fab', 'footer'],
        options,
      });
    }
  }, [isUsed, useShareButton]);
};
